import React from 'react';
import PropTypes from 'prop-types';
import { Surveys } from 'utils/types';
import SurveyDropdown from './SurveyDropdown';
import SurveyDetails from './SurveyDetails';
import { SFSurveysTenantLanguage } from "utils/types";

export default class SurveyHeader extends React.Component {

  get shouldDisplayDropdown() {
    // We only display the dropdown if there is more than one survey available
    return this.props.surveys.length > 1;
  }

  get dropdown() {
    if ( !this.shouldDisplayDropdown ) return null;
    return <SurveyDropdown surveys={this.props.surveys} selectedOption={this.props.surveyId} progressSurveyWords={this.props.progressSurveyWords} />
  }

  get selectedSurvey() {
    return this.props.surveys.find(e => e.surveyId === this.props.surveyId);
  }

  get details() {
    if ( !this.selectedSurvey ) return null;
    const updatedDate = this.props.updatedDateBySurvey[this.props.surveyId] || this.selectedSurvey.formattedUpdatedDate;
    return <SurveyDetails survey={this.selectedSurvey} surveyUpdatedDate={updatedDate} />;
  }

  render() {
    return (
      <>
        {this.dropdown}
        {this.details}
      </>
    );
  }
}

SurveyHeader.propTypes = {
  surveys: Surveys.isRequired,
  surveyId: PropTypes.number.isRequired,
  updatedDateBySurvey: PropTypes.object.isRequired,
  progressSurveyWords: SFSurveysTenantLanguage
};
